import { render, staticRenderFns } from "./InfoNotification.vue?vue&type=template&id=e68fa282&scoped=true&"
import script from "./InfoNotification.vue?vue&type=script&lang=ts&"
export * from "./InfoNotification.vue?vue&type=script&lang=ts&"
import style0 from "./InfoNotification.vue?vue&type=style&index=0&id=e68fa282&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e68fa282",
  null
  
)

export default component.exports